<template>
	<div class="coupon">
		<div class="coupon_01">
			<img src="@assets/images/handsel_0.jpg">
			<p class="title">《<strong>{{coupon_title}}</strong>》限额优惠券</p>
			<p class="title2">金额超过 <strong class="greads">{{ min_price }}</strong> 元可使用</p>
		</div>
		<div class="coupon_02">
			<img src="@assets/images/handsel_1.jpg">
			<p class="product">《{{coupon_title}}》专用</p>
			<p class="money">{{coupon_price}}</p>
			<p class="couponcode">NO.{{code}}</p>
			<div class="received">
				<p>
					<span>已领</span>
					<span><i>{{receiv_count}}</i>张</span>
				</p>
			</div>
		</div>
		<div class="infobox">
			<div class="info">
				<p class="infop1">本优惠券下单时自动减免{{coupon_price}}元</p>
				<p class="infop5">请点击下方按钮</p>
				<!-- <div class="infodiv">
					<p>签约《提分宝典》“VIP助学小群班”</p>
					<p>确保提升<strong>30~160</strong>分</p>
					<p>包头地区1万余名考生，限招300人（7理、3文）</p>
					<p>前100位报名者优惠1000元，数量有限，领完为止</p>
				</div> -->
				<div class="button">
					<div class="paybtn" @click="useCoupon(jump_url)">立即使用</div>
					<!-- <p class="infop2">今晚24时前下单</p>
					<p class="infop3">赠价值835.3元的提分伴侣组合</p>
					<p class="infop3">数量有限，赠完为止</p> -->
				</div>
				<!-- <div class="infodiv marbottom"> -->
					<!-- <p>{{receive_time}}</p> -->
					<!-- <p class="infop3">{{receive_address}}</p> -->
					<!-- <p>付款后请于2020年6月7日</p>
					<p>（上午9:00-12:00；下午14:00-17:00）至</p>
					<p class="infop3">呼和浩特市新城区西护城河巷内蒙古教育图书广场卓越书店（新世纪广场对面锦江之星旅馆西巷往北150米处路东）</p>
					<p>{{receive_address2}}</p> -->
				<!-- </div> -->
				<!-- <div class="probox">
					<img src="@assets/images/product_1.jpg">
				</div> -->
				<!-- <div class="indexbutton" @click="$router.push('/index_activity/215')">进入学习严选 >></div> -->
				<div class="bhight"></div>
			</div>
		</div>
	</div>
</template>
<script>
import { activityCouponDis } from "@api/user";
import { getProductDetail, postCartAdd } from "@api/store";
export default {
	name: "ActivityCoupon",
	components: {},
	props: {},
	data: function() {
		return {
			coupon_title:"提分宝典",
			coupon_price:"1000",
			receiv_count:"3000",//已领张数
			remain_count:"20",//剩余张数
			receive_time:"",
			receive_address:"",
			receive_address2:"",
			is_permanent:0,
			code:"T76768",
			jump_url:"/",
			productid:78,
			productValue: [],
			attr: {
			  cartAttr: false,
			  productAttr: [],
			  productSelect: {},
			  RuleData:{}
			},
			min_price:''
		}
	},
	created() {},
	watch: {
		$route(n){
			if(n){
				// this.getActivityCoupon();
			}
		}
	},
	mounted: function() {
		this.$dialog.loading.open("正在加载中");
		this.getActivityCoupon();
		// this.productCon();
	},
	methods: {
		getActivityCoupon(){
			let that = this;
			let id = that.$route.params.id;
			let urlSource = that.$cookies.get('urlSource');
			activityCouponDis(id,urlSource).then(res=>{
				that.coupon_title = res.data.issueUserInfo.coupon_title;
				that.coupon_price = res.data.issueUserInfo.coupon_price;
				that.receiv_count = res.data.issueCouponInfo.receiv_count;
				that.remain_count = res.data.issueCouponInfo.remain_count;
				that.is_permanent = res.data.issueCouponInfo.is_permanent;
				that.product_id = res.data.issueCouponInfo.product_id;
				that.code = res.data.issueUserInfo.code;
				that.jump_url = res.data.jump_url;
				that.receive_time = res.data.issueCouponInfo.receive_time;
				that.receive_address = res.data.issueCouponInfo.receive_address;
				that.receive_address2 = res.data.issueCouponInfo.receive_address2;
				that.min_price = res.data.issueUserInfo.use_min_price;
				that.$dialog.loading.close();
			}).catch(err => {
				that.$dialog.loading.close();
				that.$dialog.error(err.msg);
				if(err.msg == "领取的优惠劵已过期!"){
					// setTimeout(function(){
					// 	that.$router.push("/");
					// },1000);
				}
			});
		},
		useCoupon(url){
			window.location.href = url;
		},
		productCon: function() {
			let that = this,
			productid = that.productid;
			getProductDetail(productid).then(res => {
				that.$set(that, "productValue", res.data.productValue);
			}).catch(err => {
				that.$dialog.error(err.msg);
			});
		},
		goCat(id){
			let that = this,
			q = {
			  productId: id,
			  cartNum: 1,
			  new: 1,
			  spec_type: 0,
			  spec_values: "",
			  uniqueId: that.productValue["默认"].unique
			};
			postCartAdd(q).then(function(res) {
				that.$router.push({ path: "/order/submit/" + res.data.cartId });
			 }).catch(res => {
				return that.$dialog.toast({ mes: res.msg });
			 });
		},
	}
};
</script>
<style scoped>
	
	.coupon img {
		width: 100%;
		display: block;
	}
	.coupon_01{
		position: relative;
		/* background: url("../../../assets/images/handsel.png") 98.7% 32%; */
		/* overflow: hidden; */
		/* background-size: 205.4%; */
	}
	.coupon_01 p{
		width: 100%;
		position: absolute;
		text-align: center;
		/* margin-top: 0.7rem; */
		/* padding-bottom: 0.1rem; */
	}
	.title{
		top: 33%;
		font-size: 0.4rem;
	}
	.title2{
		top: 63%;
		font-size: 0.27rem;
	}
	.coupon_02 {
		position: relative;
	}
	.product{
		position: absolute;
		top: 10%;
		left: 15%;
		color: #fff;
		font-size: 0.3rem;
	}
	.money{
		position: absolute;
		top: 33%;
		left: 24%;
		font-size: 0.9rem;
		color: #ffd891;
	}
	.received {
		width: 1.4rem;
		height: 0.6rem;
		background: url("../../../assets/images/handsel.png") 53.5% 72.5%;
		/* background-size: 1.4rem 0.6rem; */
		position: absolute;
		top: 30%;
		right: 9.7%;
		font-size: 12px;
		text-align: center;
	}
	.received span{
		display: block;
		line-height: 0.3rem;
	}
	.received i {
		color: #ed0301;
	}
	.couponcode{
		font-size: 0.2rem;
		position: absolute;
		top: 6%;
		right: 10.5%;
	}
	.infobox{
		/* width: 7.5rem; */
		background-color: #f82a25;
		background: url("../../../assets/images/handsel.png") -0.1rem -0.1rem no-repeat;
		background-size: 205.4%;
		overflow: hidden;
		position: relative;
	}
	.info{
		width: 83%;
		margin: 0 auto;
	}
	.infodiv{
		width: 100%;
		background-color: #f8f8f8;
		border-radius: 5px;
		padding: 0.3rem 0.2rem;
		margin-top: 0.55rem;
	}
	.infodiv p{
		font-size: 0.25rem;
		color: #333;
		text-align: center;
		line-height: 0.38rem;
	}
	.infop1{
		font-size: 0.26rem;
		color: #f2221c;
		text-align: center;
		margin-top: 0.3rem;
	}
	.infop5{
		font-size: 0.26rem;
		color: #f2221c;
		text-align: center;
		line-height: 0.5rem;
	}
	.button{
		margin-top: 0.3rem;
		overflow: hidden;
	}
	.button_l,.button_r{
		width: 50%;
		float: left;
	}
	/* .paybtn,.handselbtn{
		width: 2.4rem;
		margin: 0 auto;
		padding: 0.15rem 0;
		border-radius: 17px;
		color: #fff;
		text-align: center;
		font-size: 0.27rem;
	} */
	.paybtn{
		width: 3.3rem;
		margin: 0 auto;
		padding:0.12rem 0.3rem;
		background-color: #09abff;
		border-radius: 17px;
		color: #fff;
		text-align: center;
		font-size: 0.28rem;
		font-weight: bold;
	}
	.handselbtn{
		background-color: #ff3329;
	}
	.button p{
		font-size: 0.26rem;
		/* color: #333; */
		text-align: center;
	}
	.button .infop3{
		color: #ff3329;
	}
	.infodiv .infop3{
		font-weight: bold;
		text-align: left;
	}
	.infop2{
		margin-top: 0.2rem;
	}
	.infodiv p{
		margin-top: 0.05rem;
	}
	.infodiv .infop4{
		font-size: 0.3rem;
		font-weight: bold;
		margin-top: 0.15rem;
	}
	.indexbutton{
		text-align: center;
		font-size: 0.2rem;
		border: 1px solid #e2b847;
		border-radius: 15px;
		padding: 0.07rem 0.15rem;
		position: absolute;
		right: 0.8rem;
		bottom: 1.6rem;
	}
	.bhight{
		width: 100%;
		height: 6rem;
	}
	strong.greads{
		font-size: 0.33rem;
	}
	.probox{
		width: 90%;
		margin: 0.3rem auto;
	}
	.probox img{
		width: 100%;
	}
</style>
